"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("../common");
var ElementResponses;
(function (ElementResponses) {
    var ViewContentTypeElementResponse = /** @class */ (function (_super) {
        __extends(ViewContentTypeElementResponse, _super);
        /**
         * Response containing content type element
         *
         * @constructor
         * @param {GenericElement} element - Content type element
         */
        function ViewContentTypeElementResponse(element, response, isDeveloperMode) {
            var _this = _super.call(this, response, isDeveloperMode) || this;
            _this.element = element;
            return _this;
        }
        return ViewContentTypeElementResponse;
    }(common_1.BaseKontentResponseStandardDebug));
    ElementResponses.ViewContentTypeElementResponse = ViewContentTypeElementResponse;
})(ElementResponses = exports.ElementResponses || (exports.ElementResponses = {}));
//# sourceMappingURL=responses.js.map